import { useState, useRef, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { KTIcon } from '../../../../_metronic/helpers'
import { StepperComponent } from '../../../../_metronic/assets/ts/components'
import { RegisterProducerCenterStep1 } from './RegisterProducerCenterStep1'
import { RegisterProducerCenterStep2 } from './RegisterProducerCenterStep2'
import { useTranslation } from 'react-i18next'

const RegisterProducerCenterModal = ({ showModal, hideModal ,showStep1}) => {
    const { t } = useTranslation()
    const [stepper, setStepper] = useState<StepperComponent | null>(null)
    const [loadStep2, setLoadStep2] = useState(false);
    const [nextStepSubmit, setNextStepSubmit] = useState(false);
    const stepperRef = useRef<HTMLDivElement | null>(null)
    const nextStepButtonRef = useRef<HTMLButtonElement | null>(null)
    const loadStepper = () => {
        setStepper(StepperComponent.createInsance(stepperRef.current as HTMLDivElement))
    }

    const nextStep = () => {
        if (!stepper) {
            return
        }
        stepper.goNext()
    }

    const nextStepSucceed = () => {
        setNextStepSubmit(true)
    }

    const nextStepFailed = () => {
        setNextStepSubmit(false)
    }

    const nextStepLoadSucceed = () => {
        setLoadStep2(true)
    }

    const nextStepLoadFailed = () => {
        setLoadStep2(false)
    }

    useEffect(() => {
        if (nextStepSubmit === true) {
            nextStepButtonRef.current?.click()
            setNextStepSubmit(false)
        }
    }, [nextStepSubmit])

    return (
        <Modal
            id='kt_modal_register_producercenter'
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-900px'
            show={showModal}
            //onHide={hideModal}
            onHide={() => {}} backdrop="static" keyboard={false}
            onEntered={loadStepper}
            //backdrop={true}
            onShow={nextStep}
        >
            <div className='modal-header'>
                <h2>{t('PRODUCER.REGISTER')}</h2>
                {/* begin::Close */}
                {/* <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={hideModal}>
                    <KTIcon className='fs-1' iconName='cross' />
                </div> */}
                {/* end::Close */}
            </div>
            <div className='modal-content'>
                <div className='modal-body py-lg-10 px-lg-10'>
                    <div
                        ref={stepperRef}
                        className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
                        id='kt_modal_create_app_stepper'>
                        <div className='d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px'>
                            <div className='stepper-nav ps-lg-10'>
                                {/* begin::Step 1*/}
                                <div className={showStep1 === true ? 'stepper-item current' : 'stepper-item completed'} data-kt-stepper-element='nav'>
                                    {/* begin::Wrapper*/}
                                    <div className='stepper-wrapper'>
                                        <div className='stepper-icon w-40px h-40px'>
                                            <i className='stepper-check fas fa-check'></i>
                                            <span className='stepper-number'>1</span>
                                        </div>
                                        <div className='stepper-label'>
                                            <h3 className='stepper-title'>{t('PRODUCER.PERSONAL_INFO')}</h3>
                                            <div className='stepper-desc'>{t('PRODUCER.SAVE_PERSONAL_INFO')}</div>
                                        </div>
                                    </div>
                                    {/* end::Wrapper*/}

                                    {/* begin::Line*/}
                                    <div className='stepper-line h-40px'></div>
                                    {/* end::Line*/}

                                </div>
                                {/* end::Step 1*/}

                                {/* begin::Step 2*/}
                                <div className={showStep1 === true ? 'stepper-item' : 'stepper-item current'} data-kt-stepper-element='nav'>
                                    {/* begin::Wrapper*/}
                                    <div className='stepper-wrapper'>
                                        {/* begin::Icon*/}
                                        <div className='stepper-icon w-40px h-40px'>
                                            <i className='stepper-check fas fa-check'></i>
                                            <span className='stepper-number'>2</span>
                                        </div>
                                        {/* begin::Icon*/}

                                        {/* begin::Label*/}
                                        <div className='stepper-label'>
                                            <h3 className='stepper-title'>{t('MENU.PRODUCER')}</h3>

                                            <div className='stepper-desc'>{t('PRODUCER.REGISTER')}</div>
                                        </div>
                                        {/* begin::Label*/}
                                    </div>
                                    {/* end::Wrapper*/}

                                    {/* begin::Line*/}
                                    <div className='stepper-line h-40px'></div>
                                    {/* end::Line*/}
                                </div>
                                {/* end::Step 2*/}
                            </div>
                        </div>

                        <div className='flex-row-fluid py-lg-5 px-lg-15'>
                            <RegisterProducerCenterStep1
                                nextStepSucceed={nextStepSucceed}
                                nextStepFailed={nextStepFailed}
                                nextStepLoadSucceed={nextStepLoadSucceed}
                                nextStepLoadFailed={nextStepLoadFailed}
                                showStep1={showStep1}
                            />
                            <RegisterProducerCenterStep2
                                hideModal={hideModal}
                                loadStep2={loadStep2}
                                nextStepLoadFailed={nextStepLoadFailed}
                                showStep1={showStep1}
                            />
                        </div>
                        <div>
                            <button
                                type='button'
                                className='btn btn-lg btn-primary'
                                data-kt-stepper-action='next'
                                onClick={nextStep}
                                ref={nextStepButtonRef}
                                style={{ display: 'none' }}
                            >
                                Next Step <KTIcon iconName='arrow-right' className='fs-3 ms-1 me-0' />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export { RegisterProducerCenterModal }
